module.exports = __webpack_public_path__ + "img/layoutLogo.954b3207.svg";